"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mustache_1 = __importDefault(require("mustache"));
const siteSearch = {
    processingClickEvent: null,
    baseFormProps: {},
    customFields: {},
    controller: new AbortController(),
    timer: null,
    searchDelay: 150,
    init() {
        const self = this;
        const searchTabs = document.querySelectorAll('.js-site-search');
        if (!searchTabs.length)
            return;
        console.log('site-search.init()');
        searchTabs.forEach((tab) => {
            const filters = tab.querySelector('.js-site-search-filters');
            const id = tab.id;
            if (!id)
                return false;
            const loadMoreForm = tab.querySelector('[data-search-load-more-form]');
            if (loadMoreForm) {
                self.baseFormProps[id] = Array.from(loadMoreForm.querySelectorAll('input')).filter(i => i.type === 'hidden').reduce((acc, cur) => {
                    acc[cur.name] = cur.value;
                    return acc;
                }, {});
                const submit = loadMoreForm.querySelector('[type="submit"]');
                loadMoreForm.addEventListener('submit', (e) => {
                    e.preventDefault();
                    if (self.baseFormProps[id].page === '1') {
                        self.baseFormProps[id].page = (parseInt(self.baseFormProps[id].page) + 1).toString();
                    }
                    self.getResults(id, submit);
                });
            }
            if (filters) {
                const inputs = Array.from(filters.getElementsByTagName("input"));
                self.baseFormProps[id] = Array.from(filters.querySelectorAll('input')).filter(i => i.type === 'hidden').reduce((acc, cur) => {
                    acc[cur.name] = cur.value;
                    return acc;
                }, {});
                const submit = loadMoreForm?.querySelector('[type="submit"]');
                this.saveFilters(id, inputs);
                inputs.forEach(element => {
                    element.addEventListener('change', (e) => {
                        self.saveFilters(id, inputs);
                        self.baseFormProps[id].page = '1';
                        self.getResults(id, submit);
                    });
                });
            }
            tab.addEventListener('click', (e) => {
                const target = e.target.classList.contains('search-result') ? e.target : e.target.closest('.search-result');
                if (target && target.dataset?.searchItem && target.dataset?.searchItemUrl === target.getAttribute('href')) {
                    e.preventDefault();
                    self.sendClickEvent({
                        url: target.getAttribute('href'),
                        id: target.dataset?.searchItem,
                        position: target.dataset?.searchItemPosition,
                        term: target.dataset?.searchItemTerm,
                        openInNewWindow: target.getAttribute('target') === '_blank',
                    });
                    return false;
                }
            });
            return false;
        });
    },
    saveFilters(id, inputs) {
        this.customFields[id] = [];
        inputs.forEach(input => {
            if (input.checked) {
                if (input.dataset.sort) {
                    this.baseFormProps[id].sort = input.dataset.sort;
                }
                if (input.dataset.order) {
                    this.baseFormProps[id].order = input.dataset.order;
                }
                if (input.dataset.customField) {
                    this.customFields[id].push(input.dataset.customField);
                }
            }
        });
    },
    getResults(id, submit) {
        this.controller.abort();
        this.controller = new AbortController();
        clearTimeout(this.timer);
        this.timer = setTimeout(async () => {
            const container = document.getElementById(id);
            container?.classList.add('loading');
            const context = this.baseFormProps[id].context;
            const formData = new FormData();
            if (context === 'search_page_filtered') {
                formData.append('customFields', JSON.stringify(this.customFields[id]));
            }
            fetch('/stage-ajax/siteSearch/?' + new URLSearchParams(this.baseFormProps[id]).toString(), {
                signal: this.controller.signal,
                method: context === 'search_page_filtered' ? 'POST' : 'GET',
                body: context === 'search_page_filtered' ? formData : null,
            }).then(response => response.json())
                .then((response) => {
                if (response.page) {
                    this.baseFormProps[id].page = (response.page + 1).toString();
                    ;
                }
                if (response.hits) {
                    const template = document.getElementById(`template-search-item-${id}`)?.textContent;
                    const results = document.querySelector(`[data-search-results-container=${id}]`);
                    const tabButton = document.querySelector(`[data-toggle-target=${id}]`);
                    if (template && results && response.page === 1) {
                        results.innerHTML = response.hits.map((item) => mustache_1.default.render(template, item)).join('');
                    }
                    else if (template && results) {
                        const lastChild = results?.lastElementChild;
                        lastChild?.insertAdjacentHTML('afterend', response.hits.map((item) => mustache_1.default.render(template, item)).join(''));
                    }
                    if (tabButton) {
                        tabButton.textContent = tabButton.textContent?.replace(/\d+/, response.total_hits) || '';
                    }
                }
                if (response.total_hits <= response.page * response.limit) {
                    submit?.remove();
                }
            })
                .catch((err) => {
                console.error(`Search err error: ${err.message}`);
            }).finally(() => {
                container?.classList.remove('loading');
            });
        }, this.searchDelay);
    },
    redirectBlank(url) {
        var a = document.createElement('a');
        a.target = "_blank";
        a.href = url;
        a.click();
    },
    sendClickEvent(data) {
        if (this.processingClickEvent) {
            return;
        }
        this.processingClickEvent = data.id;
        let locationChanging = false;
        const loadTargetPath = () => {
            if (data.url && !locationChanging) {
                locationChanging = true;
                this.processingClickEvent = false;
                if (data.openInNewWindow) {
                    this.redirectBlank(data.url);
                }
                else {
                    window.location = data.url;
                }
            }
        };
        const formData = new FormData();
        formData.append('id', data.id);
        formData.append('position', data.position);
        formData.append('term', data.term);
        try {
            fetch(`/stage-ajax/siteSearch/?stage-language=${document.body.getAttribute('data-language')}&context=reportClick`, {
                method: 'POST',
                body: formData,
            }).then((res) => {
                loadTargetPath();
            }).catch((err) => {
                loadTargetPath();
            });
            return true;
        }
        catch (err) {
            this.processingClickEvent = false;
            if (err instanceof Error && err.name !== 'AbortError') {
                console.log(err);
            }
        }
        // Navigate to new url after small delay, even if ajax request has not completed
        setTimeout(loadTargetPath, 500);
    },
};
exports.default = siteSearch;
